/**
 * Apply playback loudness. On iOS, volume is ignored by the browser, so
 * muted is also set so mute/unmute still works.
 */
export function applyMediaVolume(element: HTMLMediaElement, volume: number) {
  element.volume = volume
  element.muted = volume === 0
}
